import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';

@Component({
  selector: 'pcs-dropdown-toggle',
  styleUrls: ['./dropdown-toggle.component.scss'],
  template: '<ng-content></ng-content>',
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class DropdownToggleComponent {
  @Input() disabled = false;

  @HostBinding('class.disabled')
  private get isDisabled() {
    return this.disabled;
  }
}
